import {
  ZOOM_IN,
  ZOOM_OUT,
  RESET_ZOOM,
  ZOOM_IN_MUT,
  ZOOM_OUT_MUT,
  RESET_ZOOM_MUT
} from "./constants.js";

const regex = /^(tableView\/)/;

const _ZOOM_IN = ZOOM_IN.replace(regex, "");
const _ZOOM_OUT = ZOOM_OUT.replace(regex, "");
const _RESET_ZOOM = RESET_ZOOM.replace(regex, "");

export default {
  [_ZOOM_IN]({ commit }) {
    commit(ZOOM_IN_MUT);
  },
  [_ZOOM_OUT]({ commit }) {
    commit(ZOOM_OUT_MUT);
  },
  [_RESET_ZOOM]({ commit }) {
    commit(RESET_ZOOM_MUT);
  }
};
